import React, { useEffect } from 'react';
import './index.scss';
export enum RESOLUTION {
  STANDARD = 'STANDARD',
  HIGH = 'HIGH',
  SMOOTH = 'SMOOTH',
  ULTRAFAST = 'ULTRAFAST',
}
const btnListMap = new Map([
  [RESOLUTION.HIGH, '高清'],
  [RESOLUTION.STANDARD, '标准'],
  [RESOLUTION.SMOOTH, '流畅'],
  [RESOLUTION.ULTRAFAST, '极速'],
]);

const Resolution = (props: {
  onChange?: (value: RESOLUTION, mesFlag?: boolean) => void;
}) => {
  const [selectResolution, setSelectResolution] = React.useState(
    RESOLUTION.STANDARD,
  );
  const [showBtnList, setShowBtnList] = React.useState(false);
  useEffect(() => {
    props.onChange && props.onChange(RESOLUTION.STANDARD, false);
  }, []);
  const renderBtnList = () => {
    return Array.from(btnListMap.keys()).map((item) => (
      <i
        className={`resolution-btn-item ${
          item === selectResolution ? 'active' : ''
        }`}
        onClick={() => {
          setSelectResolution(item);
          props.onChange && props.onChange(item);
        }}
      >
        {btnListMap.get(item)}
      </i>
    ));
  };
  return (
    <span className='resolution-list'>
      <span
        className='selected-resolution'
        onClick={() => {
          setShowBtnList(!showBtnList);
        }}
      >
        {btnListMap.get(selectResolution)}
      </span>
      {showBtnList && (
        <span className='resolution-btn-list'>{renderBtnList()}</span>
      )}
    </span>
  );
};

export default Resolution;
